export const constants = {
    defaultPrimaryUrl: 'https://lctbo.blob.core.windows.net/lido-public/menu-items/primary/500_default.webp',
    defaultThumbnailUrl: 'https://lctbo.blob.core.windows.net/lido-public/menu-items/thumbnails/100_default.webp',
    primaryPhotoFolder: 'https://lctbo.blob.core.windows.net/lido-public/menu-items/primary',
    thumbnailPhotoFolder: 'https://lctbo.blob.core.windows.net/lido-public/menu-items/thumbnails',
    basePhotoFolder: 'https://lctbo.blob.core.windows.net/lido-public',
    storageKeys: {
        cart: 'cart',
        ExistingOrderDetails: 'existing-order-details',
        ComputationResult: 'order-computation-result',
        CreateOrderDto: 'create-order-dto',
    },
    messages: {
        invalidAssignedStore: 'Sorry, the address you selected is outside of our serviced area.',
        genericInvalidServiceHourMessage: 'Sorry, none of our stores are available to serve you at this time. Please try again later.',
        invalidServiceHourMessage: (start: number) =>
            `Sorry, the store is currently closed. Please try again at ${start}:00`,
    }
}
